import { Component, Input, OnInit } from '@angular/core';
import { CloudStatusType } from '../support.service';

@Component({
  selector: 'app-cloud-status-dialog',
  templateUrl: './cloud-status-dialog.component.html',
  standalone: false
})
export class CloudStatusDialogComponent implements OnInit {

  @Input()
  status: CloudStatusType;

  showDialog: Boolean = false;

  constructor() { }

  ngOnInit(): void {
    if (!this.operational) {
      this.showDialog = true;
    }
  }

  get cloudStatus(): CloudStatusType {
    return this.status;
  }

  get operational(): boolean {
    return this.status === 'operational';
  }

  get degraded(): boolean {
    return this.status === 'degraded';
  }

  get outage(): boolean {
    return this.status === 'outage';
  }

}
